import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { cookieUtils } from '@/utilities/cookieUtils'
import { isNullOrUndefinedOrWhiteSpace } from '@vantis/shared'
import { jwtDecode } from 'jwt-decode'

export const useAppContext = defineStore("app", () => {
  const accessToken = ref<string>();
  const tenantId = ref<string>();
  const locale = ref<string>('zh-cn');
  const backendUrl = ref<string>();
  const userId=ref<string>();
  const $reset = () => {
    accessToken.value = undefined;
    tenantId.value = undefined;
    locale.value = 'en-us';
    backendUrl.value = undefined;
    userId.value=undefined;
  }
  watch(locale, async (localeNew:string) => {
    cookieUtils.setCookie("FlexiHRlang_process",localeNew);
  }, { immediate: true });
  return { accessToken, tenantId, locale, backendUrl,userId,$reset }
});
export const initializeAppContext = () => {
  const appContext = useAppContext();
  appContext.accessToken = cookieUtils.getCookie("Authorization") || "";
  appContext.backendUrl = cookieUtils.getCookie("ProcessRequestUri") || "";
  appContext.locale = cookieUtils.getCookie("FlexiHRlang") || "en-us";
  appContext.tenantId = cookieUtils.getCookie("TenantId") || "";
  if(!isNullOrUndefinedOrWhiteSpace(appContext.accessToken)){
    const jwt=jwtDecode(appContext.accessToken);
    appContext.userId=(jwt as any).uid;
  }
  //debug
  //appContext.accessToken='CfDJ8Nml91iTZNZMhC8WqricK3RPWC-SnMLt9bB7WGQNcM3icso2NRLQOnl0p_8jYnmCEGDopQt3spG_obOWSs-orTp09Wwoi_yKh3thKhSjlSIBzvUx1vVz7YcYUjeNo1xxuEOYy0KU4V_ZEYCupRKjBB3wzecF3HZBXxM86xheem170eaSWAU_G0BfQUkR7ld-P7_4yge1nOILEtbqJZ_VBe5lgPj4d5WJn2jlzz4AZlEy_HRMiUiQ-bUUvBeGGzD3HNh0UT6g66SxrCh7NbUs3sgCXoR0nGX5Ufqh1LTBN3DVRg6ZoF3SaEGMlNCry75GkzlXXOapEhgqTdHZX78atYYTI3IujSv3u32anJ4KWnDZ5doSjvVBXoAEF7CZdMQClOqXvt08MnZz0xfhQUpweC1TwoqNDWDwaaFyPM_ZfKgmcmTiEAvyjkvwqOkMJqvJ3qjO6VnarLbfpMhJSltKjGMXQ_gaY48tmqHsHMuZWyHSOZsOd3_3AbCiAAdaM8CWw6-JuMbVr3m9os9NSB3glcmFxbOiQksc9Ht7QlUWE414RSFbJeKe2GNKWeyoKn_-4UQgWXuMRFRTcG9oUwKl2qx0mDmVdNBZPBesvE1tWZcT';
  //appContext.backendUrl="https://localhost:5001/"
  // appContext.tenantId="'DEMO_HR_7.5_Dev_FlowEngine'"
}
